import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LandingPageComponent } from './landing-page/landing-page.component';
import { TermsComponent } from '../shared/terms/terms.component';
import { PrivacyComponent } from '../shared/privacy/privacy.component';
import { SalesComponent } from './sales/sales.component';
import { SitemapComponent } from '../shared/sitemap/sitemap.component';
import { LegalComponent } from '../shared/legal/legal.component';
import { NewHomeComponent } from './home/new-home.component';
import { ProductComponent } from './product/product.component';
import { NewAboutComponent } from './about/new-about.component';
import { NewContactComponent } from './contact/new-contact.component';
import { AttendanceComponent } from './attendance/attendance.component';
import { PublicPageComponent } from './public-page/public-page.component';
import { FourPillarsComponent } from './four-pillars/four-pillars.component';
import { WhyInforidaComponent } from './why-inforida/why-inforida.component';
import { AdminStaffComponent } from './admin-staff/admin-staff.component';
import { AcademicStaffComponent } from './academic-staff/academic-staff.component';
import { ParentsComponent } from './parents/parents.component';
import { BlogsComponent } from './blogs/blogs.component';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    children: [
      {
        path: '',
        component: NewHomeComponent,
        pathMatch: 'full',
        data: { animation: 'home' },
      },
      {
        path: 'home',
        component: NewHomeComponent,
        pathMatch: 'full',
        data: { animation: 'home' },
      },
      {
        path: 'about-us',
        component: NewAboutComponent,
        pathMatch: 'full',
        data: { animation: 'about' },
      },
      {
        path: 'contact-us',
        component: NewContactComponent,
        pathMatch: 'full',
        data: { animation: 'contact' },
      },
      {
        path: 'products',
        component: ProductComponent,
        pathMatch: 'full',
        data: { animation: 'products' },
      },
      {
        path: 'four-pillars',
        component: FourPillarsComponent,
        pathMatch: 'full',
        data: { animation: 'fourPillars' },
      },
      {
        path: 'why-inforida',
        component: WhyInforidaComponent,
        pathMatch: 'full',
        data: { animation: 'whyInforida' },
      },
      {
        path: 'admin-staff',
        component: AdminStaffComponent,
        pathMatch: 'full',
        data: { animation: 'adminStaff' },
      },
      {
        path: 'academic-staff',
        component: AcademicStaffComponent,
        pathMatch: 'full',
        data: { animation: 'academicStaff' },
      },
      {
        path: 'parents',
        component: ParentsComponent,
        pathMatch: 'full',
        data: { animation: 'parents' },
      },
      {
        path: 'terms',
        component: TermsComponent,
        pathMatch: 'full',
        data: { animation: 'terms' },
      },
      {
        path: 'privacy',
        component: PrivacyComponent,
        pathMatch: 'full',
        data: { animation: 'privacy' },
      },
      {
        path: 'sales',
        component: SalesComponent,
        pathMatch: 'full',
        data: { animation: 'sales' },
      },
      {
        path: 'sitemap',
        component: SitemapComponent,
        pathMatch: 'full',
        data: { animation: 'sitemap' },
      },
      {
        path: 'legal',
        component: LegalComponent,
        pathMatch: 'full',
        data: { animation: 'legal' },
      },
      {
        path: 'blogs',
        component: BlogsComponent,
        pathMatch: 'full',
        data: { animation: 'blogs' },
      },
      {
        path: 'products/goood-morning',
        component: AttendanceComponent,
        pathMatch: 'full',
        data: { animation: 'gooodMorning' },
      },
      {
        path: 'products/QuickEnroll-AI',
        component: PublicPageComponent,
        pathMatch: 'full',
        data: { animation: 'quickEnrollAI' },
      },
      {
        path: 'products/inforida-orbit',
        component: ProductComponent,
        pathMatch: 'full',
        data: { animation: 'inforidaOrbit' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LandingPageRoutingModule {}
